import { render, staticRenderFns } from "./CharacterTest.vue?vue&type=template&id=2e4c3369&scoped=true&"
import script from "./CharacterTest.vue?vue&type=script&lang=js&"
export * from "./CharacterTest.vue?vue&type=script&lang=js&"
import style0 from "./CharacterTest.vue?vue&type=style&index=0&id=2e4c3369&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c3369",
  null
  
)

export default component.exports